import { useEffect, useState } from "react";
import { getAllSubscriptions } from "../services/subscriptions";
import HotdropdownV2 from "./HotdropdownV2";
import { useTranslation } from "react-i18next";

function SubscriptionSelector({ value, onChange }) {
  const [subscriptions, setSubscriptions] = useState([]);
  const { t } = useTranslation("general");

  useEffect(() => {
    const fetchSubscriptions = async () => {
      const data = await getAllSubscriptions();
      setSubscriptions(data.data.Subs || []);
    };

    fetchSubscriptions();
  }, []);

  const handleSubscriptionSelect = (subscription) => {
    onChange?.(subscription.id);
  };

  
  const subscriptionOptions = subscriptions.filter(sub => sub.status === "ACTIVE").map((sub) => ({
    id: sub.id,
    title: `${sub.name}  -  ${t("price")}: $${sub.pricePerMonth}  -  ${t("numberOfUsers")}: ${sub.userNumber}`,
  }));

  const selected = subscriptions.find((sub) => sub.id === value);

  return (
    <HotdropdownV2
      selected={selected}
      setSelected={handleSubscriptionSelect}
      initOptions={subscriptionOptions}
      thick
    />
  );
}

export default SubscriptionSelector;